import {
  getAccessToken,
  getFromStorage,
  setToStorage,
} from "library/sessionStorageHelper";
import { useCallback, useState } from "react";
import { useSiteData } from "react-event-tracker";
import { UserProfile } from "../types";
import { UserContext } from "./UserContext";

export const UserProvider = ({ children }) => {
  const { setSiteData, getSiteData } = useSiteData();
  const siteData = getSiteData();

  // initialize profile in context
  // check if user logged in and profile exists in localstorage
  const [profile, setProfile] = useState<UserProfile | null>(() => {
    const storageProfile = getFromStorage("profile");
    const userData = storageProfile ? JSON.parse(storageProfile) : null;
    setSiteData({
      ...siteData,
      user: {
        authenticationStatus: userData ? "logged in" : "not logged in",
        profile: {
          emailAddress: userData?.email ?? "",
          profileId: userData?.id ?? userData?.email ?? "",
          customerMasterId: getAccessToken() ?? "",
        },
      },
    });
    return userData;
  });

  const customSetProfile = useCallback(
    (profileToUpdate: UserProfile | null) => {
      setProfile(profileToUpdate);
      setToStorage(
        "profile",
        profileToUpdate ? JSON.stringify(profileToUpdate) : null,
      );
    },
    [],
  );

  return (
    <UserContext.Provider
      value={{
        profile,
        isLoggedIn: profile !== null,
        setProfile: customSetProfile,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
